// extracted by css-extract-rspack-plugin
export default {"boxBackground":"header-fragment__Box_boxBackground__0TqfK"};